import { ProfileSearch } from '@app/Components/ProfileSearch';
import { Drawer } from '@app/Components/Drawer';
import * as React from 'react';

type ProfileSearchOptions = {};

type ProfileSearchContextType = {
  openProfileSearch: (options?: ProfileSearchOptions) => void;
  closeProfileSearch: () => void;
};

const ProfileSearchContext = React.createContext<ProfileSearchContextType | undefined>(undefined);

export const ProfileSearchProvider = ({ children }: React.PropsWithChildren) => {
  const [show, setShow] = React.useState(false);
  const [options, setOptions] = React.useState<ProfileSearchOptions | undefined>();

  const openProfileSearch = (opts?: ProfileSearchOptions) => {
    setOptions(opts);
    setShow(true);
  };

  const closeProfileSearch = () => setShow(false);

  return (
    <ProfileSearchContext.Provider value={{ openProfileSearch, closeProfileSearch }}>
      {children}
      <Drawer show={show} position="left" onHide={closeProfileSearch}>
        <ProfileSearch />
      </Drawer>
    </ProfileSearchContext.Provider>
  );
};

export const useProfileSearch = () => {
  const ctx = React.useContext(ProfileSearchContext);
  if (!ctx) {
    throw new Error('useProfileSearch must be used within ProfileSearchProvider');
  }
  return ctx;
};
